<template>
  <div v-loading="loading">
    <div v-if="type !== 'category' && type != 'category_main' && type !='category_main_d'">
      <el-table
        :data="list"
        width="100%"
        height="420"
        highlight-current-row
        @current-change="handleCurrentChange">
        <el-table-column
          property="id"
          label="ID"
          width="120">
        </el-table-column>
        <el-table-column
          property="title"
          :label="type == 'store_list' ? '门店名称':'标题名称'"
          >
        </el-table-column>
        <el-table-column
          property="links"
          label="链接"
          v-if="type === 'custom_link'"
          >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        :page-size="params.pageSize"
        layout="prev, pager, next"
        :total="total"
        @current-change="pageChange">
      </el-pagination>
    </div>
    <el-table
      v-else
      :data="list"
      height="420"
      row-key="id"
      default-expand-all
      highlight-current-row
      @current-change="handleCurrentChange"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
        prop="id"
        label="ID"
        width="180">
      </el-table-column>
      <el-table-column
        prop="title"
        label="分类名">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import api from '@/api'

  export default {
    props: {
      type: {
        type: String,
        default: ''
      },
      keywords: {
        type: String,
        default: ''
      },
      store: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        list: [],
        params: {
          pageSize: 10,
          page: 1
        },
        total: 0,
        loading: false
      }
    },
    computed: {
      ...mapGetters([
        'template_name'
      ])
    },
    watch: {
      type(val) {
        if (val) {
          this.params.page = 1
          this.fetch(val)
        }
      },
      keywords(val) {
        this.params.page = 1
        this.fetch(this.type)
      },
      store(val) {
        this.params.page = 1
        this.fetch(this.type)
      }
    },
    methods: {
      fetch (type) {
        this.loading = true
        let query = JSON.parse(JSON.stringify(this.params))
        console.log(this.store)
        switch (type) {
          case 'goods':
            Object.assign(query, {
              item_type: 'normal',
              keywords: this.keywords,
              distributor_id: this.store.id || ''
            })
            api.goods.getItemsList(query).then(res => {
              let list = []
              //增加链接参数
              res.data.data.list.map(item => {
                list.push({
                  id: item.itemId,
                  title: item.itemName,
                  imgUrl: item.pics[0],
                  item_bn:item.item_bn
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'regactivity':
            Object.assign(query, {
              is_valid: true
            })
            api.selfhelpform.regActivityEasylist(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.activity_id,
                  title: item.activity_name
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'store':
            Object.assign(query, {
              is_valid: true,
              name: this.keywords
            })
            api.marketing.getDistributorList(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.distributor_id,
                  title: item.name
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'category':
            var d='';
            if(this.$route.query && this.$route.query.distributor_id !=undefined){
              this.params.distributor_id=this.$route.query.distributor_id;
              d=1;
            }
            api.goods.getCategory(this.params).then(res => {
              let items = []
              if(d== 1 &&res.data.data.length<1 ){
                this.$message({message:'前先前往店铺添加分类！',type:'error'})
              }
              res.data.data.map(item => {
                let itemObj = {
                  id: item.category_id,
                  title: item.category_name
                }
                // if (item.children.length) {
                //   let childs = []
                //   item.children.map(child => {
                //     let childObj = {
                //       id: child.category_id,
                //       title: child.category_name
                //     }
                //     if (child.children.length) {
                //       let grands = []
                //       child.children.map(grand => {
                //         const grandObj = {
                //           id: grand.category_id,
                //           title: grand.category_name
                //         }
                //         grands.push(grandObj)
                //       })
                //       Object.assign(childObj, { children: grands })
                //     }
                //     childs.push(childObj)
                //   })
                //   Object.assign(itemObj, { children: childs })
                // }
                items.push(itemObj)
              })
              this.list = items
              this.loading = false
            })
            break;
          case 'category_main':
              var d='';
              if(this.$route.query && this.$route.query.distributor_id !=undefined){
                  this.params.distributor_id=this.$route.query.distributor_id;
                  d=1;
              }
              // let parms = this.params
              // parms.is_main_category = true;
              api.goods.getCategory({page:this.params.page,pageSize:this.params.pageSize,is_main_category:true}).then(res => {
                  let items = []
                  if(d== 1 &&res.data.data.length<1 ){
                      this.$message({message:'前先前往店铺添加分类！',type:'error'})
                  }
                  res.data.data.map(item => {
                      let itemObj = {
                          id: item.category_id,
                          title: item.category_name
                      }
                      // console.log(item.children)
                      if (item.children) {
                          let childs = []
                          item.children.map(child => {
                              let childObj = {
                                  id: child.category_id,
                                  title: child.category_name
                              }
                              if (child.children) {
                                  let grands = []
                                  child.children.map(grand => {
                                      const grandObj = {
                                          id: grand.category_id,
                                          title: grand.category_name
                                      }
                                      grands.push(grandObj)
                                  })
                                  Object.assign(childObj, { children: grands })
                              }
                              childs.push(childObj)

                          })
                          Object.assign(itemObj, { children: childs })
                      }
                      items.push(itemObj)
                  })
                  this.list = items
                  this.loading = false
              })
              break;

          case 'category_main_d':
                var d='';
                if(this.$route.query && this.$route.query.distributor_id !=undefined){
                    this.params.distributor_id=this.$route.query.distributor_id;
                    d=1;
                }
                // let parms = this.params
                // parms.is_main_category = true;
                api.goods.getCategory({page:this.params.page,pageSize:this.params.pageSize,is_main_category:true}).then(res => {
                    let items = []
                    if(d== 1 &&res.data.data.length<1 ){
                        this.$message({message:'前先前往店铺添加分类！',type:'error'})
                    }
                    res.data.data.map(item => {
                        let itemObj = {
                            id: item.category_id,
                            title: item.category_name
                        }
                        // console.log(item.children)
                        if (item.children) {
                          let childs = []
                          item.children.map(child => {
                            let childObj = {
                              id: child.category_id,
                              title: child.category_name
                            }
                              if (child.children) {
                                  let grands = []
                                  child.children.map(grand => {
                                      const grandObj = {
                                          id: grand.category_id,
                                          title: grand.category_name
                                      }
                                      grands.push(grandObj)
                                  })
                                  Object.assign(childObj, { children: grands })
                              }
                              childs.push(childObj)

                          })
                          Object.assign(itemObj, { children: childs })
                        }
                        items.push(itemObj)
                    })
                    this.list = items
                    this.loading = false
                })
                break;
          case 'distributor_tag':
            Object.assign(query, {
              tag_name: this.keywords
            })
            api.marketing.getTagList(query).then(res => {
              let items = []
              res.data.data.list.map(item => {
                let itemObj = {
                  id: item.tag_id,
                  title: item.tag_name
                }
                items.push(itemObj)
              })
              this.list = items
              this.loading = false
            })
            break;
          case 'tag':
            Object.assign(query, {
              tag_name: this.keywords
            })
            api.goods.getTagList(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.tag_id,
                  title: item.tag_name
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'article':
            Object.assign(query, {
              title: this.keywords
            })
            api.article.getArticleList(this.params).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.article_id,
                  title: item.title
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'planting':
            Object.assign(query, {
              article_type: 'bring',
              title: this.keywords
            })
            api.article.getArticleList(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.article_id,
                  title: item.title
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'link':
            this.list = [{
              title: '会员开通',
              id: 'vipgrades'
            },{
              title: '楼层引导',
              id: 'floorguide'
            }]
            this.total = 1
            this.loading = false
            break;
          case 'marketing':
            this.list = [{
              title: '限时团购',
              id: 'groups_list'
            }]
            this.total = 1
            this.loading = false
            break;
          case 'seckill':
            Object.assign(query, {
              status: 'valid',
              name: this.keywords
            })
            api.promotions.seckillActivityGetList(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.seckill_id,
                  title: item.activity_name
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'custom_page':
            Object.assign(query, {
              template_name: this.template_name,
              page_name: this.keywords
            })
            api.wxa.getCustomPageList(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                list.push({
                  id: item.id,
                  title: item.page_name
                })
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            })
            break;
          case 'custom_link':
            Object.assign(query, {
              template_name: this.template_name,
              title: this.keywords
            })
            api.wxa.getCustomLinkPageList(query).then(res => {
              let list = []
              res.data.data.list.map(item => {
                if (item.is_open == 1) {
                  list.push({
                    id: item.id,
                    title: item.title,
                    links: item.links
                  })
                }
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            });
            break;
          case 'custom_category':
            var flag = 0;
            if (this.$route.query && this.$route.query.distributor_id !=undefined) {
              this.params.distributor_id = this.$route.query.distributor_id;
              flag = 1;
            }
            api.marketing.getCustomCategory(this.params).then(res => {
              let items = []
              if (flag == 1 && res.data.data.list.length < 1) {
                this.$message({message:'前先前往店铺添加分类！', type:'error'})
              }
              res.data.data.list.map(item => {
                let itemObj = {
                  id: item.id,
                  title: item.category_name
                }
                items.push(itemObj)
              })
              this.list = items
              this.loading = false
              this.total = res.data.data.total_count
            })
            break;
          case 'store_list':
            Object.assign(query, {
              template_name: this.template_name,
              shop_type_name: this.keywords
            })
            console.log('query',query)
            api.marketing.getShopTypes(query).then(res => {
              console.log('res',res)
              let list = []
              res.data.data.list.map(item => {
                if (item.status == 0) {
                  list.push({
                    id: item.shop_type_id,
                    title: item.shop_type_name
                  })
                }
              })
              this.list = list
              this.total = res.data.data.total_count
              this.loading = false
            });
            break;
          default:

        }
      },
      pageChange (val) {
        this.params.page = val
        this.fetch(this.type)
      },
      handleCurrentChange (val) {
        this.$emit('onClick', val)
      }
    },
    mounted () {
      this.fetch(this.type)
    }
  }
</script>

<style scoped lang="scss">
  .pager {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// list.vue?502d30af